import React, { useEffect, useState } from 'react';
import { Col, Row, Form } from 'antd';
import EdenredTypo from '@sharedComponent/typography';
import EdenredHeader from '@pages/main-layout/components/main-header';
import Input from '@sharedComponent/text-field';
import EdenredButton from '@sharedComponent/button';

const CompanyEstablishmentID = ({ history }) => {
	const [form] = Form.useForm();
	const [, forceUpdate] = useState();
	useEffect(() => {
		forceUpdate({});
	}, [forceUpdate]);

	const onFinish = (values) => {
		history.push({ pathname: '/company/industry' });
	};
	return (
		<>
			<EdenredHeader />
			<Row className="company-establishment-id-container">
				<Col xl={24} lg={24} md={24} sm={24} xs={24} className="establishment-id-header">
					<EdenredTypo>Enter The WPS Establishment ID:</EdenredTypo>
				</Col>
				<Col xl={24} lg={24} md={24} sm={24} xs={24}>
					<Form form={form} onFinish={onFinish}>
						<Row className="company-establishment-id-form">
							<Col xl={11} lg={11} md={12} sm={24} xs={24} className="establishment-id-text-field">
								<Form.Item name="Establishment ID">
									<Input labels="Establishment ID" labelClassName="inputlabelrequired" />
								</Form.Item>
							</Col>
						</Row>
						<Col xl={8} lg={8} md={8} sm={24} xs={24} className="establishment-id-button">
							<Form.Item shouldUpdate={true}>
								{() => (
									<EdenredButton
										disabled={!form.isFieldsTouched(true) || form.getFieldsError().filter(({ errors }) => errors.length).length}>
										Next
									</EdenredButton>
								)}
							</Form.Item>
						</Col>
					</Form>
				</Col>
				<Col className="link-button">
					<EdenredButton type="link">I don’t know the WPS Establishment ID</EdenredButton>
				</Col>
			</Row>
		</>
	);
};

export default CompanyEstablishmentID;
